<template>
  <div>
    <v-layout column v-if="shopLoad" align-center>
      <progress-q></progress-q>
    </v-layout>
     <v-label><b>La seguente funzionalità è in BETA TEST. </b></v-label>
    <v-layout row wrap v-if="!shopLoad">
     
      <!-- COMPLEANNI -->
      <v-flex xs12 sm12 md12 lg6 pa-2>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-icon class="q-text-whitesmoke mr-2">cake</v-icon>
            <v-toolbar-title>{{ getString("Notifiche compleanno") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-switch
              v-model="settings.birthdayEnabled"
              color="white"
              hide-details
              class="mt-0"
            ></v-switch>
          </v-toolbar>
          <v-card-text>
            <p class="grey--text text--darken-1">
              {{ getString("Invia automaticamente un messaggio ai clienti nel giorno del loro compleanno (se la data di nascita è stata inserita).") }}
            </p>
            <v-layout row wrap>
              <v-flex xs12 md6 pr-2>
                <label>{{ getString("Giorni prima del compleanno") }}</label>
                <v-text-field
                  v-model.number="settings.birthdayDaysBefore"
                  solo
                  type="number"
                  min="0"
                  max="30"
                  :label="getString('0 = nel giorno stesso')"
                  :disabled="!settings.birthdayEnabled"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <label>{{ getString("Titolo messaggio") }}</label>
                <v-text-field
                  v-model="settings.birthdayTitle"
                  solo
                  maxlength="80"
                  counter
                  :label="getString('Titolo')"
                  :disabled="!settings.birthdayEnabled"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <label>{{ getString("Messaggio") }} <span class="caption grey--text">— {{ getString('Puoi usare {nome} per il nome del cliente') }}</span></label>
                <rich-text-editor v-model="settings.birthdayMessage" :disabled="!settings.birthdayEnabled"></rich-text-editor>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <!-- NOTIFICHE VISITA -->
      <v-flex xs12 lg6 pa-2>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-icon class="q-text-whitesmoke mr-2">star_rate</v-icon>
            <v-toolbar-title>{{ getString("Notifiche visita") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="caption q-text-whitesmoke mr-3"
              >{{ reviewMessages.length }} / {{ maxReviewMessages }}</span
            >
            <v-btn
              icon
              dark
              :disabled="reviewMessages.length >= maxReviewMessages"
              @click="addReviewMessage"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <p class="grey--text text--darken-1">
              {{ getString("Invia automaticamente un messaggio ai clienti prima o dopo una visita. Puoi configurare più regole con trigger diversi (es. recensione 1h dopo, reminder 24h prima).") }}
            </p>

            <v-alert :value="reviewMessages.length === 0" color="grey lighten-1" class="body-2">
              {{ getString("Nessuna notifica visita configurata. Usa il + per aggiungerne una.") }}
            </v-alert>

            <v-expansion-panel v-if="reviewMessages.length > 0" v-model="openReviewPanels" :expand="true">
              <v-expansion-panel-content
                v-for="(msg, index) in reviewMessages"
                :key="index"
              >
                <template v-slot:header>
                  <v-layout align-center>
                    <v-switch
                      v-model="msg.enabled"
                      color="orange"
                      hide-details
                      class="mt-0 mr-3"
                      @click.stop
                    ></v-switch>
                    <span :class="{ 'grey--text': !msg.enabled }">
                      {{ msg.title || getString('Notifica') + ' ' + (index + 1) }}
                      <span class="caption grey--text ml-2" v-if="msg.hours">
                        — {{ msg.hours }}h {{ msg.trigger === 'before' ? getString('prima della visita') : getString('dopo la visita') }}
                      </span>
                      <span class="caption grey--text ml-1">
                        · {{ msg.repeatMode === 'every_n' ? getString('ogni') + ' ' + msg.repeatEvery + ' ' + getString('visite') : getString('ogni visita') }}
                      </span>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="removeReviewMessage(index)">
                      <v-icon color="red lighten-2">delete</v-icon>
                    </v-btn>
                  </v-layout>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6 pr-2>
                        <label>{{ getString("Quando") }}</label>
                        <v-select
                          v-model="msg.trigger"
                          solo
                          :items="triggerOptions"
                          item-text="label"
                          item-value="value"
                          :label="getString('Seleziona')"
                          :disabled="!msg.enabled"
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6 pl-2>
                        <label>{{ getString("Ore") }}</label>
                        <v-text-field
                          v-model.number="msg.hours"
                          solo
                          type="number"
                          min="1"
                          max="168"
                          :label="getString('N. ore (es. 1)')"
                          :disabled="!msg.enabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 pr-2>
                        <label>{{ getString("Frequenza") }}</label>
                        <v-select
                          v-model="msg.repeatMode"
                          solo
                          :items="repeatModeOptions"
                          item-text="label"
                          item-value="value"
                          :disabled="!msg.enabled"
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-flex>
                      <v-flex xs6 pl-2 v-if="msg.repeatMode === 'every_n'">
                        <label>{{ getString("Ogni N visite") }}</label>
                        <v-text-field
                          v-model.number="msg.repeatEvery"
                          solo
                          type="number"
                          min="2"
                          max="100"
                          :label="getString('N. visite (es. 5)')"
                          :disabled="!msg.enabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{ getString("Titolo messaggio") }}</label>
                        <v-text-field
                          v-model="msg.title"
                          solo
                          maxlength="80"
                          counter
                          :label="getString('Titolo')"
                          :disabled="!msg.enabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{ getString("Messaggio") }} <span class="caption grey--text">— {{ getString('Variabili: {nome} = nome cliente, {shop} = nome negozio, {ora} = orario appuntamento') }}</span></label>
                        <rich-text-editor v-model="msg.message" :disabled="!msg.enabled"></rich-text-editor>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-alert
              :value="reviewMessages.length >= maxReviewMessages"
              color="orange lighten-2"
              class="mt-3 body-2"
            >
              {{ getString("Limite massimo raggiunto") }} ({{ maxReviewMessages }}).
            </v-alert>
          </v-card-text>
        </v-card>
      </v-flex>

         <!-- MESSAGGI PERIODICI -->
      <v-flex xs12 lg6 pa-2>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-icon class="q-text-whitesmoke mr-2">schedule_send</v-icon>
            <v-toolbar-title>{{ getString("Messaggi periodici") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="caption q-text-whitesmoke mr-3"
              >{{ periodicMessages.length }} / {{ maxPeriodicMessages }}</span
            >
            <v-btn
              icon
              dark
              :disabled="periodicMessages.length >= maxPeriodicMessages"
              @click="addPeriodicMessage"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <p class="grey--text text--darken-1">
              {{ getString("Invia automaticamente messaggi promozionali ai clienti con una cadenza fissa. Puoi configurare più messaggi con cadenze diverse.") }}
            </p>

            <v-alert :value="periodicMessages.length === 0" color="grey lighten-1" class="body-2">
              {{ getString("Nessun messaggio periodico configurato. Usa il + per aggiungerne uno.") }}
            </v-alert>

            <v-expansion-panel v-if="periodicMessages.length > 0" v-model="openPanels" :expand="true">
              <v-expansion-panel-content
                v-for="(msg, index) in periodicMessages"
                :key="index"
              >
                <template v-slot:header>
                  <v-layout align-center>
                    <v-switch
                      v-model="msg.enabled"
                      color="orange"
                      hide-details
                      class="mt-0 mr-3"
                      @click.stop
                    ></v-switch>
                    <span :class="{ 'grey--text': !msg.enabled }">
                      {{ msg.title || getString('Messaggio') + ' ' + (index + 1) }}
                      <span class="caption grey--text ml-2" v-if="msg.value">
                        — {{ getString('ogni') }} {{ msg.value }} {{ unitLabel(msg.unit) }}
                      </span>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="removePeriodicMessage(index)">
                      <v-icon color="red lighten-2">delete</v-icon>
                    </v-btn>
                  </v-layout>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs6 pr-2>
                        <label>{{ getString("Ogni") }}</label>
                        <v-text-field
                          v-model.number="msg.value"
                          solo
                          type="number"
                          min="1"
                          :label="getString('Quantità')"
                          :disabled="!msg.enabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs6 pl-2>
                        <label>{{ getString("Unità") }}</label>
                        <v-select
                          v-model="msg.unit"
                          solo
                          :items="periodicUnits"
                          item-text="label"
                          item-value="value"
                          :label="getString('Seleziona')"
                          :disabled="!msg.enabled"
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{ getString("Titolo messaggio") }}</label>
                        <v-text-field
                          v-model="msg.title"
                          solo
                          maxlength="80"
                          counter
                          :label="getString('Titolo')"
                          :disabled="!msg.enabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{ getString("Messaggio") }} <span class="caption grey--text">— {{ getString('Broadcast: inviato a tutti i clienti del negozio') }}</span></label>
                        <rich-text-editor v-model="msg.message" :disabled="!msg.enabled"></rich-text-editor>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-alert
              :value="periodicMessages.length >= maxPeriodicMessages"
              color="orange lighten-2"
              class="mt-3 body-2"
            >
              {{ getString("Limite massimo raggiunto") }} ({{ maxPeriodicMessages }}).
            </v-alert>
          </v-card-text>
        </v-card>
      </v-flex>


      <!-- CLIENTI INATTIVI -->
      <v-flex xs12 lg6 pa-2>
        <v-card class="dash-card">
          <v-toolbar class="q-orange-bk q-text-whitesmoke" height="50px">
            <v-icon class="q-text-whitesmoke mr-2">person_off</v-icon>
            <v-toolbar-title>{{ getString("Clienti inattivi") }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <span class="caption q-text-whitesmoke mr-3"
              >{{ inactiveMessages.length }} / {{ maxInactiveMessages }}</span
            >
            <v-btn
              icon
              dark
              :disabled="inactiveMessages.length >= maxInactiveMessages"
              @click="addInactiveMessage"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <p class="grey--text text--darken-1">
              {{ getString("Invia automaticamente un messaggio ai clienti che non prenotano da un certo numero di giorni. Puoi usare {nome} per il nome del cliente.") }}
            </p>

            <v-alert :value="inactiveMessages.length === 0" color="grey lighten-1" class="body-2">
              {{ getString("Nessuna regola configurata. Usa il + per aggiungerne una.") }}
            </v-alert>

            <v-expansion-panel v-if="inactiveMessages.length > 0" v-model="openInactivePanels" :expand="true">
              <v-expansion-panel-content
                v-for="(msg, index) in inactiveMessages"
                :key="index"
              >
                <template v-slot:header>
                  <v-layout align-center>
                    <v-switch
                      v-model="msg.enabled"
                      color="orange"
                      hide-details
                      class="mt-0 mr-3"
                      @click.stop
                    ></v-switch>
                    <span :class="{ 'grey--text': !msg.enabled }">
                      {{ msg.title || getString('Regola') + ' ' + (index + 1) }}
                      <span class="caption grey--text ml-2" v-if="msg.days">
                        — {{ getString('inattivo da') }} {{ msg.days }} {{ getString('giorni') }}
                      </span>
                    </span>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="removeInactiveMessage(index)">
                      <v-icon color="red lighten-2">delete</v-icon>
                    </v-btn>
                  </v-layout>
                </template>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 md4 pr-2>
                        <label>{{ getString("Inattivo da almeno (giorni)") }}</label>
                        <v-text-field
                          v-model.number="msg.days"
                          solo
                          type="number"
                          min="1"
                          :label="getString('Giorni')"
                          :disabled="!msg.enabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{ getString("Titolo messaggio") }}</label>
                        <v-text-field
                          v-model="msg.title"
                          solo
                          maxlength="80"
                          counter
                          :label="getString('Titolo')"
                          :disabled="!msg.enabled"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <label>{{ getString("Messaggio") }} <span class="caption grey--text">— {{ getString('Puoi usare {nome} per il nome del cliente') }}</span></label>
                        <rich-text-editor v-model="msg.message" :disabled="!msg.enabled"></rich-text-editor>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <v-alert
              :value="inactiveMessages.length >= maxInactiveMessages"
              color="orange lighten-2"
              class="mt-3 body-2"
            >
              {{ getString("Limite massimo raggiunto") }} ({{ maxInactiveMessages }}).
            </v-alert>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>

    <!-- SALVA STICKY -->
    <div class="autonotif-sticky-save" :class="{ 'autonotif-sticky-save--dark': isDarkMode }">
      <v-progress-linear indeterminate active v-if="saving" class="ma-0"></v-progress-linear>
      <v-btn
        class="q-orange-bk q-text-whitesmoke ma-2"
        :disabled="saving"
        @click="save"
      >
        <v-icon left>save</v-icon>
        {{ getString("Salva impostazioni") }}
      </v-btn>
    </div>

  </div>
</template>

<script>
import ajax from "../../../ajax.js";
import ProgressQ from "../ProgressQ";
import RichTextEditor from "../../utils/RichTextEditor";

export default {
  name: "ShopAutoNotifications",
  props: ["shopID", "tab"],
  components: {
    ProgressQ,
    RichTextEditor,
  },
  mounted: function () {
    if (this.shopID > 0) {
      this.load();
    }
  },
  watch: {
    shopID: function () {
      if (this.shopID > 0) {
        this.load();
      }
    },
    tab: function () {
      if (this.shopID > 0 && !this.loaded) {
        this.load();
      }
    },
  },
  data: () => ({
    shopLoad: false,
    saving: false,
    loaded: false,
    maxPeriodicMessages: 3,
    maxReviewMessages: 3,
    maxInactiveMessages: 3,
    periodicMessages: [],
    reviewMessages: [],
    inactiveMessages: [],
    openPanels: [],
    openReviewPanels: [],
    openInactivePanels: [],
    settings: {
      birthdayEnabled: false,
      birthdayDaysBefore: 0,
      birthdayTitle: "",
      birthdayMessage: "",
    },
    periodicUnits: [
      { label: "Giorni", value: "days" },
      { label: "Mesi", value: "months" },
      { label: "Anni", value: "years" },
    ],
    triggerOptions: [
      { label: "Dopo la visita", value: "after" },
      { label: "Prima della visita", value: "before" },
    ],
    repeatModeOptions: [
      { label: "Ogni visita", value: "always" },
      { label: "Ogni N visite", value: "every_n" },
    ],
  }),
  computed: {
    isDarkMode: function () {
      return localStorage.getItem("darkMode") ? true : false;
    },
  },
  methods: {
    getString: function (key) {
      return this.$store.state.currentTranslator.getString(key);
    },
    unitLabel: function (unit) {
      const map = { days: "giorni", months: "mesi", years: "anni" };
      return map[unit] || unit;
    },
    addReviewMessage: function () {
      if (this.reviewMessages.length < this.maxReviewMessages) {
        this.reviewMessages.push({
          enabled: true,
          trigger: 'before',
          hours: 1,
          title: '',
          message: '',
          repeatMode: 'always',
          repeatEvery: 1,
        });
        this.openReviewPanels = this.reviewMessages.map(
          (_, i) => i === this.reviewMessages.length - 1
        );
      }
    },
    removeReviewMessage: function (index) {
      this.reviewMessages.splice(index, 1);
      this.openReviewPanels.splice(index, 1);
    },
    addPeriodicMessage: function () {
      if (this.periodicMessages.length < this.maxPeriodicMessages) {
        this.periodicMessages.push({
          enabled: true,
          value: 30,
          unit: "days",
          title: "",
          message: "",
        });
        // Vuetify 1.x con :expand richiede array di booleani, uno per panel
        this.openPanels = this.periodicMessages.map(
          (_, i) => i === this.periodicMessages.length - 1
        );
      }
    },
    removePeriodicMessage: function (index) {
      this.periodicMessages.splice(index, 1);
      this.openPanels.splice(index, 1);
    },
    addInactiveMessage: function () {
      if (this.inactiveMessages.length < this.maxInactiveMessages) {
        this.inactiveMessages.push({
          enabled: true,
          days: 60,
          title: '',
          message: '',
        });
        this.openInactivePanels = this.inactiveMessages.map(
          (_, i) => i === this.inactiveMessages.length - 1
        );
      }
    },
    removeInactiveMessage: function (index) {
      this.inactiveMessages.splice(index, 1);
      this.openInactivePanels.splice(index, 1);
    },
    load: function () {
      let self = this;
      self.shopLoad = true;
      ajax.axios
        .get(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/autonotifications",
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          if (response.data && response.data.data) {
            const payload = response.data.data;
            const s = payload.settings || payload;
            self.maxPeriodicMessages = payload.maxPeriodicMessages || 3;
            self.maxReviewMessages = payload.maxReviewMessages || 3;
            self.settings = Object.assign({}, self.settings, {
              birthdayEnabled: s.birthdayEnabled,
              birthdayDaysBefore: s.birthdayDaysBefore,
              birthdayTitle: s.birthdayTitle || "",
              birthdayMessage: s.birthdayMessage || "",
            });
            self.periodicMessages = Array.isArray(s.periodicMessagesList)
              ? s.periodicMessagesList
              : Array.isArray(s.periodicMessages) ? s.periodicMessages : [];
            self.reviewMessages = Array.isArray(s.reviewMessagesList)
              ? s.reviewMessagesList
              : Array.isArray(s.reviewMessages) ? s.reviewMessages : [];
            self.inactiveMessages = Array.isArray(s.inactiveMessagesList)
              ? s.inactiveMessagesList
              : Array.isArray(s.inactiveMessages) ? s.inactiveMessages : [];
          }
          self.loaded = true;
          self.shopLoad = false;
        })
        .catch(function (error) {
          self.shopLoad = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
    save: function () {
      let self = this;
      self.saving = true;
      ajax.axios
        .put(
          ajax.baseUrl() + "/admin/shops/shop/" + self.shopID + "/autonotifications",
          Object.assign({}, self.settings, {
            periodicMessages: self.periodicMessages,
            reviewMessages: self.reviewMessages,
            inactiveMessages: self.inactiveMessages,
          }),
          {
            headers: self.$store.getters.tokenHeader,
            withCredentials: true,
          }
        )
        .then(function (response) {
          ajax.validateToken(response.headers, self.$store);
          self.saving = false;
          self.$emit("siteAlertSuccess", self.getString("Impostazioni notifiche salvate"));
        })
        .catch(function (error) {
          self.saving = false;
          var auth = ajax.checkAuth(error, self.$store, self.$router);
          self.$emit(
            "siteAlert",
            auth
              ? self.getString("Non hai l'autorizzazione")
              : error.response.data.errorMessage
          );
        });
    },
  },
};
</script>

<style scoped>
.autonotif-sticky-save {
  position: sticky;
  bottom: 36px;
  z-index: 10;
  background: white;
  border-top: 1px solid #e0e0e0;
  padding: 4px 8px;
  text-align: center;
}
.autonotif-sticky-save--dark {
  background: #424242;
  border-top-color: #666;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/pieces/ShopAutoNotifications.vue